import { useContext } from 'react';
import { FallbackProps } from 'react-error-boundary';
import { ResponsiveContext } from 'grommet';
import { CircleAlert } from 'grommet-icons';
import { Box, Card, CardBody, CardHeader, Text } from '/src/components';
import { DesktopLayout } from '/src/layouts';
import { errorMessages } from '/src/lib/errors';

export const RootErrorPage: React.ComponentType<FallbackProps> = () => {
  const screenSize = useContext(ResponsiveContext);
  const isMobile = screenSize === 'small' || screenSize === 'medium';

  return (
    <DesktopLayout>
      <Box flex="grow" justify="center" align="center">
        <Card flex="shrink" width={!isMobile ? '35%' : '80%'} margin={{ bottom: 'xlarge' }}>
          <CardHeader title="Error" icon={<CircleAlert color="brand" />}></CardHeader>
          <CardBody>
            <Box pad={{ vertical: 'xsmall' }}>
              <Text fontFamily="Lato, sans-serif">{errorMessages.default}</Text>
            </Box>
          </CardBody>
        </Card>
      </Box>
    </DesktopLayout>
  );
};
